export const translations =  {
    en: {
      filters: 'Filters',
      valid_until: 'Valid until',
      filter_instructors_only: 'Instructors Only',
      filter_active_members_only: 'Active Members Only',
      has_hagar: 'Has A HAGAR License Number',
      filter_by_province: 'Filter by Province',
      wing_types: {
        pg: 'Paragliding',
        hg: 'Hang Gliding',
        both: 'Both'
      },
      prev: 'Prev',
      next: 'Next',
      search: 'Search for member by their first, last name or member number',
      loading: 'Loading',
      no_results: 'Sorry, there are not members that match your search.',
      all_members: 'Looking for a past member?',
      all_members_button: 'Include non-active members',
      provinces: {
        ab: 'Alberta',
        bc: 'British Columbia',
        mb: 'Manitoba',
        nb: 'New Brunswick',
        nl: 'Newfoundland and Labrador',
        ns: 'Nova Scotia',
        on: 'Ontario',
        pe: 'Prince Edward Island',
        qc: 'Québec',
        sk: 'Saskatchewan',
        nt: 'Northwest Territories',
        nu: 'Nunavut',
        yt: 'Yukon Territory',
        other: 'Other'
      },
      rating: 'rating',
      first_aid: 'first aid',
      members_found: 'members found'
    },
    fr: {
      filters: 'Filtres',
      valid_until: "Valable jusqu'au",
      filter_instructors_only: 'Instructeurs seulement',
      filter_active_members_only: 'Membres actifs uniquement',
      has_hagar: 'Possède un numéro de licence HAGAR',
      filter_by_province: 'Filtrer par Province',
      wing_types: {
        pg: 'Parapente',
        hg: 'Deltaplane',
        both: 'Les deux'
      },
      prev: 'Précédente',
      next: 'Prochaine',
      search: 'Rechercher un membre par son prénom, son nom ou son numéro de membre.',
      loading: 'Chargement',
      no_results: "Désolé, il n'y a pas de membres qui correspondent à votre recherche.",
      all_members: 'Vous cherchez un ancien membre?',
      all_members_button: 'Inclure les membres non actifs',
      provinces: {
        ab: 'Alberta',
        bc: 'Colombie-Britannique',
        mb: 'Manitoba',
        nb: 'Nouveau-Brunswick',
        nl: 'Terre-Neuve-et-Labrador',
        ns: 'Nouvelle-Écosse',
        on: 'Ontario',
        pe: 'Île-du-Prince-Édouard',
        qc: 'Québec',
        sk: 'Saskatchewan',
        nt: 'Territoires du Nord-Ouest',
        nu: 'Nunavut',
        yt: 'Yukon Territoire',
        other: 'Autre'
      },
      rating: 'notation',
      first_aid: 'premiers secours',
      members_found: 'membres trouvés'
    }
  }